import script from "./article-add.vue?vue&type=script&setup=true&lang=js"
export * from "./article-add.vue?vue&type=script&setup=true&lang=js"

import "./article-add.vue?vue&type=style&index=0&id=9c76a900&scoped=true&lang=scss"
import "./article-add.vue?vue&type=style&index=1&id=9c76a900&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c76a900"]])

export default __exports__